import { OpaccDateRangePicker } from '../../lib/daterangepicker/opacc.lib.daterangepicker.js';
import {default as OpaccDateRangeL10n} from '../../lib/daterangepicker/l10n/index.js';

/** @module form */

/**
 * Basisklasse für die Datums und Zeitauswahl mittels "Picker"
 *
 */
export class OpaccFormElementDateTimePicker {
	/**
	 *
	 *
	 * @param {*} inputField
	 * @param {*} config
	 * @returns {*}
	 */
	createDateTimePicker(inputField, config) {
		return new OpaccDateRangePicker(inputField, config);
	}

	/**
	 *
	 *
	 * @param {*} element
	 */
	triggerDateTimePickerEvents(element) {
		element.config.onChange.push( (selectedDates, dateStr, instance) => {
			instance.input.setAttribute('value', dateStr);
		});
		element.config.onClose.push( (selectedDates, dateStr, instance) => {
			if (instance.config.allowInput) {
				instance.setDate(instance._input.value, true);
			}
		});
	}

	// /**
	//  *
	//  *
	//  * @param {*} lang
	//  * @returns {*}
	//  */
	// async getLocale(lang) {
	// 	let locale = null;
    //     let filename = null;

	// 	switch (+lang) {
	// 	case 1:
	// 		locale = 'German';
    //         filename = 'de.js';
	// 		break;
    //     case 2:
    //         locale = 'French';
    //         filename = 'fr.js';
	// 		break;
    //     case 3:
    //         locale = 'Italian';
    //         filename = 'it.js';
	// 		break;
	// 	default:
	// 		locale = 'English';
    //         filename = 'default.js';
	// 		break;
	// 	}

    //     await import(`./../../lib/daterangepicker/l10n/${filename}`);
	// 	return locale;
	// }


    /**
	 *
	 *
	 * @param {*} lang
	 * @returns {*}
	 */
	getLocale(lang) {
		var locale = null;

		switch (+lang) {
		case 1:
			locale = 'de';
			break;
        case 2:
            locale = 'fr';
			break;
        case 3:
            locale = 'it';
			break;
		default:
			locale = 'en';
			break;
		}

        return OpaccDateRangeL10n[locale];
	}
}
